import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { InvestigationService } from '../services/investigation.service';
import { HrccService } from '../services/hrcc.service';
import { SickLeaveListService } from '../services/sick-leave-list.service';
import { CommonService } from '../services/common.service';
import { DomSanitizer } from '@angular/platform-browser';
import {trigger, state, style, animate, transition} from '@angular/animations';

@Component({
  selector: 'app-investigation-view',
  templateUrl: './investigation-view.component.html',
  styleUrls: ['./investigation-view.component.css'],
  animations: [
    // Each unique animation requires its own trigger. The first argument of the trigger function is the name
    trigger('rotatedState', [
      state('default', style({ transform: 'rotate(0)' })),
            state('rotated90', style({ transform: 'rotate(90deg)' })),
            state('rotated180', style({ transform: 'rotate(180deg)' })),
            state('rotated270', style({ transform: 'rotate(270deg)' })),
            state('rotated360', style({ transform: 'rotate(360deg)' })),
            transition('default => rotated90', animate('200ms ease-out')),
            transition('rotated90 => rotated180', animate('200ms ease-out')),
            transition('rotated180 => rotated270', animate('200ms ease-out')),
            transition('rotated270 => rotated360', animate('200ms ease-out')),
            
  ])
]
})
export class InvestigationViewComponent implements OnInit {

  public sickLeave;
  public count;
  public patternViewEnableFlag: boolean;
  public patternViewData;
  public sickLeaveObject;
  public certificateData;

  public sickLeave_fake = {
    "absenceid": null,
    "revisionkey": null,
    "empid": null,
    "allocatedtoexpert": null,
    "expertname": null,
    "allocatedtohradmin": null,
    "hrname": null,
    "statusabsenceexpert": null,
    "statusabsenceexpert_desc": null,
    "statushradmin": 2,
    "statushradmin_desc": null,
    "illnesstype": null,
    "recordcreateddate": null,
    "datesmismatch": true,
    "isreasonverified": true,
    "potentialphotocopy": false,
    "signatureseenbefore": false,
    "doctorsseen": 2,
    "sameasrejectedholiday": false,
    "coincideswithmajorevnt": false,
    "signaturedectected": true,
    "csvgenerated": null,
    "ocrcertdate": null,
    "ocrstartdate": null,
    "ocrenddate": null,
    "noocr_date": null,
    "nocertificate": null,
    "issuetype": ""
  }

  public dataObject;
  public dataObject_fake = {
    "employeeId": "u362401",
    "prefdLang": "N/A",
    "absenceInfo": {
      "txnID": "N/A",
      "absenceID": "N/A",
      "typeOfLeave": "N/A",
      "leavePin": "N/A",
      "leaveSubmittedOn": null,
      "fromDate": null,
      "toDate": null,
      "certificateInfo": {
        "certificateAttached": "N",
        "certificateAddedOn": null,
        "certificateRefID": "N/A",
        "certificateURI": "N/A"
      },
      "addressDuringSickness": {
        "addressType": "N/A",
        "address": {
          "streetName": "N/A",
          "streetNumber": "N/A",
          "boxNo": "N/A",
          "city": "N/A",
          "postalCode": "N/A",
          "country": "N/A"
        }
      }
    }
  };

  public employeeObject;
  public employeeObject_fake = {
    "firstName": "N/A",
    "lastName": "N/A",
    "username": "N/A",
    "emailID": "N/A",
    "empID": "N/A",
    "prefdLang": "fr",
    "empType": "N/A",
    "contactNumber": "N/A",
    "contactNumPersonal": "N/A",
    "addressInfo": {
      "addressType": "N/A",
      "address": {
        "streetName": "N/A",
        "streetNumber": "N/A",
        "boxNo": "N/A",
        "city": "N/A",
        "postalCode": "N/A",
        "country": "N/A"
      }
    },
    "managerInfo": {
      "firstName": "N/A",
      "lastName": "N/A",
      "contactNumber": "N/A",
      "emailID": "N/A",
      "empID": "N/A"
    }
  };

  public rotateDegree = 0;
  public rotateDegreeString = '0';

  public empDetailsFlag: boolean;
  public absenceDetailsFlag: boolean;
  public absenceDetailsPostgreFlag: boolean;
  public certificateFlag: boolean;

  public observedPatternList = [
    // {
    //   'pattern': 'Event Cooccurence',
    //   'patternObserved': '3rd absence the day after a football game of RSC Anderlecht',
    //   'patternObservedOn': '- Observed on 5/8 last sickness registrations',
    //   'relatedScreen': 'type2'
    // },
    {
      'pattern': 'Possible Photocopy',
      'patternObserved': 'Similar certificates have been used for previous absences',
      'patternObservedOn': '- Observed on 3/8 last sickness registrations',
      'relatedScreen': 'type1'
    }
  ];

  constructor(public commonService: CommonService,
    public sickLeaveService: SickLeaveListService,
    public hrccService: HrccService,
    public investigationService: InvestigationService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private _sanitizer: DomSanitizer) { }

  getIrregularityByAbsenceId(absenceId, employeeId) {
    this.hrccService.getIrregularityByAbsenceId(absenceId, employeeId)
      .subscribe(
        (res: any) => {
          this.absenceDetailsFlag = res.status === 'success' ? true : false;
          if (this.absenceDetailsFlag) {
            this.dataObject = res.response;
            if (this.dataObject.absenceInfo.certificateInfo.certificateAttached === 'Y') {
              this.getCertificate(this.dataObject.absenceInfo.certificateInfo.certificateRefID);
            }
          } else {
            this.dataObject = this.dataObject_fake;
            this.absenceDetailsFlag = true;
            alert('Not able to get the absence information!');
          }
        },
        (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveService.redirectToSAB();
          }
          this.dataObject = this.dataObject_fake;
          this.absenceDetailsFlag = true;
          alert('Not able to get the absence information!');
        }
      );
  }

  getEmployeeByEmployeeId(employeeId) {
    this.hrccService.getEmployeeByEmployeeId(employeeId)
      .subscribe(
        (res: any) => {
          this.empDetailsFlag = res.status === 'success' ? true : false;
          if (this.empDetailsFlag === true) {
            this.employeeObject = res.response.emp;
          } else {
            this.employeeObject = this.employeeObject_fake;
            this.empDetailsFlag = true;
            alert('Not able to get the employee information!');
          }
        },
        (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveService.redirectToSAB();
          }
          this.employeeObject = this.employeeObject_fake;
          this.empDetailsFlag = true;
          alert('Not able to get the employee information!');
        });
  }

  ngOnInit() {
    this.count = 1;
    this.certificateData = '';
    this.patternViewEnableFlag = false;
    this.empDetailsFlag = false;
    this.absenceDetailsFlag = false;
    this.absenceDetailsPostgreFlag = false;

    const absenceId = this.activatedRoute.snapshot.paramMap.get('absenceId');
    let employeeId = this.activatedRoute.snapshot.paramMap.get('employeeId');
    // this.sickLeave = JSON.parse(localStorage.getItem('obj'));

    this.getPatternCount(absenceId, employeeId);
    this.getIrregularityByAbsenceId(absenceId, employeeId);
    this.getEmployeeByEmployeeId(employeeId);
    this.getIrregularityByAbsenceIdFromPostgre(absenceId);
  }

  getIrregularityByAbsenceIdFromPostgre(absenceID) {
    this.commonService.getIrregularityByAbsenceId(absenceID)
      .subscribe(
        (res) => {
          if (res.status === 'success') {
            this.sickLeave = {};
            this.sickLeave = res.response;
            this.absenceDetailsPostgreFlag = true;
          } else {
            this.absenceDetailsPostgreFlag = true;
          }
        },
        (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveService.redirectToSAB();
          }
          this.sickLeave = this.sickLeave_fake;
          this.absenceDetailsPostgreFlag = true;
        }
      );
  }

  getIssuesIntoArray(list) {
    let tempArray = [];
    let splitedArray = []
    splitedArray = list.split(';');
    for (let i = 0; i < splitedArray.length; i++) {
      if (splitedArray[i].trim() !== '') {
        tempArray.push(splitedArray[i]);
      }
    }
    return tempArray;
  }

  getPatternCount(absenceId, employeeId) {
    this.investigationService.getPatternCount(absenceId, employeeId)
      .subscribe(
        (res) => {
          this.count = res.response.count;
        },
        (err) => {
          this.count = 0;
        }
      );
  }

  getCertificate(certificateId) {
    this.commonService.getCertificate(certificateId)
      .subscribe(
        (res) => {
          if (res.status === 'success') {
            this.certificateFlag = false;
            this.certificateData = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/*;base64,'
              + res.response.base64image);
          } else {
            this.certificateFlag = true;
          }
        }, (err) => {
          this.certificateFlag = true;
        })
  }

  openPatternView(item) {
    this.patternViewData = item;
    this.patternViewEnableFlag = true;
  }

  closePatternView(closeFlag: boolean) {
    this.patternViewEnableFlag = !closeFlag;
  }

  changeStauts(data) {
    let ids = [];
    let temp = {
      'absenceid': this.sickLeave.absenceid,
      'revisionkey': this.sickLeave.revisionkey,
      'statusabsenceexpert': data
    }
    ids.push(temp);

    this.sickLeaveService.updateHrExpertAllocation(ids, [], sessionStorage.getItem('user'))
      .subscribe(
        (res) => {
          if (res.status === 'success') {
            alert('Leave status changed for Absence ID ' + this.sickLeave.absenceid);
            // this.router.navigate(['/sll']);
            this.getIrregularityByAbsenceIdFromPostgre(this.sickLeave.absenceid);
          } else {
            if (res.status === 'fail') {
              alert('Error while updating the status!');
            }
          }
        },
        (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveService.redirectToSAB();
          }
          alert('Error while updating the status!');
        }
      );
  }
  state: string = 'default';

    rotate() {
        //this.state = (this.state === 'default' ? 'rotated' : 'default');
        if(this.state === 'default'){
          this.state = 'rotated90'
        }else if(this.state === 'rotated90'){
           this.state = 'rotated180'
        }else if(this.state === 'rotated180'){
           this.state = 'rotated270'
        }else if(this.state === 'rotated270'){
           this.state = 'rotated360'
           this.state = 'default'
        }else{
          this.state = 'default'
        }
    }

  rotateStyle: string;
  rotateImage() {
    this.rotateStyle = 'rotate';
    this.rotateDegree += 90;
    if (this.rotateDegree === 360) {
      this.rotateDegree = 0;
    }
    this.rotateDegreeString = this.rotateDegree.toString();
  }

}



// WEBPACK FOOTER //
// ./src/app/investigation-view/investigation-view.component.ts